import request from '@/utils/request'

export function getEquityData(query) {
	return request({
		url: '/api/web/v1/customerProfile/equity',
		method: 'get',
		params: query,
	})
}